import { render, staticRenderFns } from "./GlobalPaymentBadge.vue?vue&type=template&id=25542c1d"
import script from "./GlobalPaymentBadge.vue?vue&type=script&lang=js"
export * from "./GlobalPaymentBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports